import colorMod from 'color';

export default ({ color, fontSize, typography }) => ({
  filterRankContainer: {
    marginLeft: 20,
    marginRight: 20,
  },
  inputField: {
    display: 'flex',
    alignItems: 'center',
  },
  textInput: {
    width: 80,
    height: 40,
    color: color.bodyText,
    display: 'inline-block',
    fontFamily: typography.bodyText,
    fontSize: fontSize.buttonText,
    marginBottom: '0px !important',
    marginTop: '0px !important',
    '& input': {
      borderBottom: 0,
      height: 39,
      width: '100%',
    },
    '&:hover div': {
      borderColor: color.borderColorLight,
    },
  },
  invalidTextInput: {
    '& input': {
      borderColor: color.error,
    },
    '&:focus div': {
      boxShadow: `0 0 0 1px #ffffff, 0 0 0 2px ${color.error}`,
    },
    '& input:focus + div': {
      boxShadow: `0 0 0 1px #ffffff, 0 0 0 2px ${color.error}`,
    },
    '& div': {
      borderColor: color.error,
    },
  },
  textInputField: {
    padding: '0 !important',
  },
  filterRankSizeContainer: {
    marginTop: 35,
    fontSize: fontSize.small,
  },
  rankSizeBtn: {
    color: color.primaryButtonBackground,
    background: color.primaryButtonText,
    marginLeft: 10,
    height: 40,
    borderRadius: 3,
    width: 42,
    fontFamily: typography.buttonText,
    fontSize: fontSize.buttonText,
    border: '1px solid',
    borderColor: color.primaryButtonBackground,
    '&:hover': {
      background: `${colorMod(color.primaryButtonBackground).alpha(0.05).string()} !important`,
    },
    '&:focus': {
      background: `${colorMod(color.primaryButtonBackground).alpha(0.05).string()} !important`,
      outline: 'none',
    },
    '&:active': {
      background: `${colorMod(color.primaryButtonBackground).alpha(0.05).string()} !important`,
      borderStyle: 'solid',
    },
  },
  helperMessage: {
    color: color.smallText,
    fontFamily: typography.smallText,
    fontSize: fontSize.smallText,
  },
  button: {
    margin: '10px 10px',
  },
  filterLabel: {
    fontSize: fontSize.small,
  },
  label: {
    marginBottom: 5,
    color: color.bodyText,
    fontFamily: typography.bodyText,
    fontSize: fontSize.bodyText,
    fontWeight: 'bold',
  },
  errorMessage: {
    color: color.red,
    fontSize: fontSize.smallText,
  },
});
